import { create } from 'zustand'

export const useCRMStore = create((set, get) => ({
    currentMonth: new Date().getMonth(),
    currentYear: new Date().getFullYear(),

    setCurrentMonth: (value) => set(() => ({currentMonth: value})),
    setCurrentYear: (value) => set(() => ({currentYear: value})),

    isLoading: false,
    setIsLoading: (value) => set(() => ({isLoading: value})),

    search: "",
    setSearch: (value) => set(() => ({search: value})),
}))